<template>
  <div class='serviceTodoDetail'>
    <div class="mask">
      <div class="wrapper">
        <div @click="close" class="close">
          <i class="iconfont icon-cha"></i>
        </div>

        <div class="detailContainer">
          <h2>事项流转轨迹</h2>
          <v-table
              :row-click-color="'rgba(239,239,239,0.5)'"
              style="width:100%"
              :is-horizontal-resize="true"
              :columns="columns"
              :table-data="tableDataList"
              :show-vertical-border="false"
          ></v-table>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  //vuex
  import {mapState, mapGetters, mapMutations} from 'vuex'
  //axios
  import axios from 'axios'
  import apiConfig from 'common/js/api_config'
  //通信总线
  import Bus from 'common/js/bus.js'

  export default {
    name: "serviceTodoDetail",
    data() {
      return {
        columns: [
          // {
          //   field: 'workitemid',
          //   title: '工作项ID',
          //   width: 100,
          //   titleAlign: 'center',
          //   columnAlign: 'center',
          //   isResize: true,
          // },
          {
            field: 'custome', title: '序号', width: 50, titleAlign: 'center', columnAlign: 'center',
            formatter: function (rowData, rowIndex, pagingIndex, field) {
              return rowIndex + 1
            }, isFrozen: true, isResize: true
          },
          {
            field: 'activityinstname',
            title: '工作项名称',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
          },
          {
            field: 'checktype',
            title: '状态',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
            formatter: (rowData, rowIndex, pagingIndex, field) => {
              if (field === 'checktype' && !rowData[field]) {
                return '<span class="stateDesc notStart">未开始</span>'
              }
              switch (rowData[field]) {
                case '完成':
                  return '<span class="stateDesc finish">完成</span>'
                case '通过':
                  return '<span class="stateDesc pass">通过</span>'
                default:
                  return rowData[field]
              }

            }
          },
          // {
          //   field: 'processInstId',
          //   title: '所属流程实例',
          //   width: 100,
          //   titleAlign: 'center',
          //   columnAlign: 'center',
          //   isResize: true,
          // },
          // {
          //   field: 'isTimeout',
          //   title: '是否超时',
          //   width: 100,
          //   titleAlign: 'center',
          //   columnAlign: 'center',
          //   isResize: true,
          // },
          // {
          //   field: 'priority',
          //   title: '优先级',
          //   width: 100,
          //   titleAlign: 'center',
          //   columnAlign: 'center',
          //   isResize: true,
          // },
          // {
          //   field: 'participant',
          //   title: '参与者ID',
          //   width: 100,
          //   titleAlign: 'center',
          //   columnAlign: 'center',
          //   isResize: true,
          // },
          {
            field: 'checkname',
            title: '参与者姓名',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
          },

          {
            field: 'starttime',
            title: '开始时间',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
            formatter: this.formatTime
          },

          {
            field: 'endtime',
            title: '完成时间',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
            formatter: this.formatTime
          },
          {
            field: 'checkinfo',
            title: '审批意见',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
            formatter: (rowData, rowIndex, pagingIndex, field) => {
              if (!rowData['checktype']) {
                return `<span class="suggestDesc notStart">${rowData[field]}</span>`
              }
              switch (rowData['checktype']) {
                case '完成':
                  return `<span class="suggestDesc finish">${rowData[field]}</span>`
                case '通过':
                  return `<span class="suggestDesc pass">${rowData[field]}</span>`
                default:
                  return rowData[field]
              }

            }
          },


        ],
        tableDataList: []
      }
    },
    props: [],
    computed: {},
    watch: {},
    methods: {
      close() {
        this.$parent.processinstid = null
      },
      async _initDetail() {
        let detail = await axios.post(apiConfig.REQUEST_URL + '/shall/front_getServiceItemDetail?processinstid=' + this.$parent.processinstid)
        if (!detail.data.status) {
          return
        }
        this.tableDataList = detail.data.data[0]
      },
      formatTime(rowData, rowIndex, pagingIndex, field) {
        if (rowData[field]) {
          return rowData[field].split('.')[0]
        }
        return ''
      }
    },
    filters: {},
    components: {},
    activated() {
    },
    mounted() {
      this._initDetail()
    }
  }
</script>

<style lang="stylus" scoped>
  @import "../../common/stylus/config.styl"
  .serviceTodoDetail
    setPositionFull()
    background-color rgba(0, 0, 0, 0.5)

    .wrapper
      setPositionFull()
      margin auto

      .detailContainer
        position absolute
        left 0
        right 0
        top 50px
        bottom 50px
        margin auto
        border 1px solid #004a94
        overflow-y scroll
        background-color #ffffff

        & > h2
          margin-top 10px
          margin-bottom 10px
          text-align center
          line-height 2
          color #004a94
          border-left 2px solid #004a94

        & >>> .v-table-views
          .v-table-body-cell
            .suggestDesc
              font-weight bold

            .stateDesc
              font-weight bold

            .notStart
              color #f60

            .finish
              color #004a94

            .pass
              color #1d970e
</style>



// WEBPACK FOOTER //
// src/components/service/serviceTodoDetail.vue